// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_-O7","cls2":"ReportList-cls2_VWo ReportList-cls1_-O7"};